import { Tag } from '@factorialco/deprecated-design-system'
import { CommandBarEmployeeSearchDocument } from 'generated/resources/graphql'
import { maxBy } from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmployeeAvatar } from 'modules/employees/components/EmployeeAvatar'

import type { ResultType, SearchPlugin, SearchPluginHook } from '../types'

const useSearchEmployees: SearchPluginHook = (search) => {
  const { navigation } = useNavigation()
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data } = useQuery(CommandBarEmployeeSearchDocument, { variables: { search, companyId } })

  const filteredResults: ResultType[] = useUnsafeMemo(
    () =>
      data?.employees.employeeNamesConnection.nodes.map((employee) => {
        const leave = maxBy(employee.upcomingLeavesConnection?.nodes || [], 'finishOn')
        const leaveType = leave?.leaveType?.translatedName
        const leaveTitle = leaveType ? leaveType : i18n.t('time_off.absent')

        const path = navigation.employees.id.fullPath({ id: employee.id.toString() })
        const result: ResultType = {
          id: employee.id.toString(),
          text: `${employee.preferredName ?? employee.firstName} ${employee.lastName}`,
          IconComponent: () => <EmployeeAvatar employee={employee} disableQuickView />,
          type: 'navigation',
          navigationPath: path,
          DetailsComponent: leave ? () => <Tag type="tangerine">{leaveTitle}</Tag> : undefined,
          score: 10,
        }

        return result
      }) || [],
    [data, navigation.employees.id]
  )

  return {
    id: 'employees',
    results: filteredResults,
    title: i18n.t('command_bar.plugins.employees.title'),
    loading: false,
  }
}

export const searchEmployees: SearchPlugin = {
  hook: useSearchEmployees,
}
